import { render, staticRenderFns } from "./SeizureForm.vue?vue&type=template&id=7450fa08&"
import script from "./SeizureForm.vue?vue&type=script&lang=js&"
export * from "./SeizureForm.vue?vue&type=script&lang=js&"
import style0 from "./SeizureForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports